module.exports = "data:image/gif;base64,R0lGODlhBQADAIAAAP///////yH5BAEKAAEALAAAAAAFAAMAAAIDjI9ZADs="